<template>
  <component :is="to ? 'router-link' : 'div'" :to="to || null" class="kpi-tile" :class="'tone-' + tone">
    <span class="kpi-head"><span class="kpi-icon"><VnIcon :name="icon" /></span>{{ label }}</span>
    <strong class="kpi-value vn-num">{{ value }}</strong>
    <span v-if="hint" class="kpi-hint" :class="'hint-' + hintTone">{{ hint }}</span>
  </component>
</template>

<script>
import VnIcon from '@/components/VnIcon/index.vue';

export default {
  name: 'KpiTile',
  components: { VnIcon },
  props: {
    label: { type: String, required: true },
    value: { type: String, required: true },
    hint: { type: String, default: '' },
    hintTone: { type: String, default: 'muted' }, // muted | good | bad
    tone: { type: String, default: 'navy' }, // navy | teal | pink | amber
    icon: { type: String, default: 'chart' },
    to: { type: String, default: '' },
  },
};
</script>

<style scoped>
.kpi-tile { position: relative; display: grid; gap: 6px; align-content: start; min-height: 118px; padding: 16px 16px 14px; overflow: hidden;
  background: var(--surface); border: 1px solid var(--line); border-radius: var(--r-md); color: var(--text); text-decoration: none; }
/* the tone shows as a slanted bar on the leading edge, like the brand's three bars */
.kpi-tile::before { content: ''; position: absolute; inset-inline-start: 0; top: 14px; width: 4px; height: 26px; background: var(--tone); transform: skewY(var(--slant)); }
a.kpi-tile { transition: border-color .18s var(--ease-out), box-shadow .18s var(--ease-out), transform .18s var(--ease-out); }
a.kpi-tile:hover { border-color: var(--navy-900); box-shadow: var(--shadow-hard); transform: translate(-2px, -2px); text-decoration: none; color: var(--text); }
a.kpi-tile:focus-visible { outline: 3px solid var(--focus); outline-offset: 2px; }
.kpi-head { display: flex; align-items: center; gap: 8px; color: var(--text-3); font-size: 12px; font-weight: 700; line-height: 1.6; }
.kpi-icon { flex: none; width: 32px; height: 32px; display: grid; place-items: center; border-radius: var(--r-sm); background: var(--tone-bg); color: var(--navy-900); --icon-accent: var(--tone); font-size: 15px; }
.tone-navy { --tone: var(--navy-700); --tone-bg: var(--navy-100); }
.tone-teal { --tone: var(--teal-500); --tone-bg: var(--teal-50); }
.tone-pink { --tone: var(--pink-500); --tone-bg: var(--pink-50); }
.tone-amber { --tone: var(--amber-500); --tone-bg: var(--amber-50); }
.kpi-value { font-size: 28px; line-height: 1.25; font-weight: 900; color: var(--navy-900); }
.kpi-hint { font-size: 11.5px; line-height: 1.6; color: var(--text-3); }
.hint-good { color: var(--teal-700); font-weight: 700; }
.hint-bad { color: var(--pink-700); font-weight: 700; }
</style>
